import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc92b652"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MGraficoAtividadesPorPeriodo",
  "data-testid": "MGraficoAtividadesPorPeriodo"
}
const _hoisted_2 = { class: "MGraficoAtividadesPorPeriodo__Titulo" }
const _hoisted_3 = {
  key: 0,
  class: "MGraficoAtividadesPorPeriodo__Legenda"
}

import { watch, ref, computed } from "vue"
  import { storeToRefs } from "pinia"
  import Skeleton from "primevue/skeleton"
  import Chart from "primevue/chart"
  import Badge from "primevue/badge"
  import { usarListarEstatisticasStore } from "@/store/estatisticas/ListarEstatisticas/ListarEstatisticas.store"
  import {
    processarDadosGraficoDeAtividades,
    usarUtilitariosGraficoDeAtividades,
  } from "./MGraficoAtividadesPorPeriodo.script"
  import { ScriptableContext } from "chart.js"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { useI18n } from "vue-i18n"

  interface Props {
    dataInicial: Date
    dataFinal: Date
    estaCarregando: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MGraficoAtividadesPorPeriodo',
  props: {
    dataInicial: null,
    dataFinal: null,
    estaCarregando: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    dataInicial: Date
    dataFinal: Date
    estaCarregando: boolean
  }

  const { pegarTotalDeDiasDeUmPeriodo, converterAcumuloDeMinutosParaHoras } =
    usarDataHora()

  const { atividadesGrafico } = storeToRefs(usarListarEstatisticasStore())

  const { t } = useI18n()

  

  const dadosDoGrafico = ref({})

  const configuracoesDoGrafico = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      tooltip: {
        callbacks: {
          label: (contexto: ScriptableContext<"bar">) => {
            const { formatarLegendasTooltip } =
              usarUtilitariosGraficoDeAtividades()
            const legendaDaColuna = contexto.dataset?.label
            const valorDaColuna = contexto.parsed?.y

            return formatarLegendasTooltip(legendaDaColuna, valorDaColuna)
          },
        },
      },
    },
    scales: {
      y: {
        ticks: {
          callback: function (value, index, values) {
            return converterAcumuloDeMinutosParaHoras(value).horas
          },
        },
      },
    },
  }

  const atualizarGrafico = () => {
    const dadosDoGraficoEstadoAtualizado = criarDadosDoGraficoEstadoAtualizado()
    dadosDoGrafico.value = dadosDoGraficoEstadoAtualizado
  }

  const criarDadosDoGraficoEstadoAtualizado = () => {
    const periodo = {
      dataInicial: props.dataInicial,
      dataFinal: props.dataFinal,
    }
    const { definirCoresParaGraficoDeAtividades } =
      usarUtilitariosGraficoDeAtividades()
    const { corAtividadesRealizadas, corAtividadesPlanejadas } =
      definirCoresParaGraficoDeAtividades()
    const {
      listaDeLegendasDoGrafico,
      listaDeTotalDeMinutosRealizadasNoPeriodo,
      listaDeTotalDeMinutosPlanejadosNoPeriodo,
    } = processarDadosGraficoDeAtividades(
      atividadesGrafico.value,
      periodo,
      tipoDePeriodo.value
    )

    return {
      labels: [...listaDeLegendasDoGrafico],
      datasets: [
        {
          label: t("horasPlanejadas"),
          data: [...listaDeTotalDeMinutosPlanejadosNoPeriodo],
          backgroundColor: corAtividadesPlanejadas,
        },
        {
          label: t("horasRealizadas"),
          data: [...listaDeTotalDeMinutosRealizadasNoPeriodo],
          backgroundColor: corAtividadesRealizadas,
        },
      ],
    }
  }

  const totalDeDiasDoPeriodo = computed(() => {
    const dataInicial = new Date(props.dataInicial)
    const dataFinal = new Date(props.dataFinal)

    try {
      validarDatas(dataInicial, dataFinal)

      return pegarTotalDeDiasDeUmPeriodo(dataInicial, dataFinal)
    } catch (error) {
      return 0
    }
  })

  function validarDatas(dataInicial, dataFinal) {
    if (isNaN(dataInicial.getTime()) || isNaN(dataFinal.getTime())) {
      throw new Error(t('asDatasInformadasNaoSaoValidas'))
    }

    if (dataFinal < dataInicial) {
      throw new Error(t("dataFinalDeveSerMaiorOuIgualDataInicial"))
    }
  }

  const tipoDePeriodo = computed(() => {
    const totalDeDiasDeQuatroSemanas = 28
    return totalDeDiasDoPeriodo.value >= totalDeDiasDeQuatroSemanas
      ? "semanal"
      : "diario"
  })

  const ehPeriodoSemanal = computed(() => {
    return tipoDePeriodo.value === "semanal"
  })

  watch([atividadesGrafico], () => {
    atualizarGrafico()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.estaCarregando)
      ? (_openBlock(), _createBlock(_unref(Skeleton), {
          key: 0,
          class: "MGraficoAtividadesPorPeriodo__Carregamento",
          "data-testid": "MGraficoAtividadesPorPeriodo__Carregamento",
          height: "445px",
          width: "100%"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('horasDeAtividadesPlanejadasXRealizadas')), 1),
          _createVNode(_unref(Chart), {
            "aria-label": "Gráfico de Atividades Realizadas e Planejadas no período",
            class: "MGraficoAtividadesPorPeriodo__Grafico",
            data: dadosDoGrafico.value,
            "data-testid": "MGraficoAtividadesPorPeriodo__Grafico",
            options: configuracoesDoGrafico,
            role: "img",
            type: "bar"
          }, null, 8, ["data"]),
          (_unref(ehPeriodoSemanal))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(Badge), {
                  value: _unref(t)('cadaPeriodoIndicadoCorrespondeUmaSemana')
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})